<!-- echartscom.vue -->
<template>
  <div class="chart-view">
    <div :id="echarts" class="box" ref="echarts"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'Bar',
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    color: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    echarts() {
      return 'echarts-' + Math.random() * 100000
    }
  },
  mounted() {
    this.drawCharts()
  },
  methods: {
    drawCharts() {
      var myChart = echarts.init(document.getElementById(this.echarts))
      myChart.setOption({
        xAxis: {
          type: 'category',
          data: ['企业一', '企业二', '企业三', '企业四', '企业五', '企业六', '企业七']
        },
        yAxis: {
          type: 'value'
        },
        color: ['#cd1705', '#e47401', '#1890ff', '#cd1705', '#e47401', '#1890ff', '#cd1705'],
        series: [
          {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
            itemStyle: {
              normal: {
                //这里是重点
                color: function (params) {
                  //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                  var colorList = ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622']
                  return colorList[params.dataIndex]
                }
              }
            }
          }
        ]
      })
    }
  },

  watch: {
    color: {
      handler(n, o) {
        this.color = n
        console.log('--->', this.color)
        this.drawCharts()
      }
    }
  }
}
</script>

<style scoped>
.box {
  width: 100%;
  height: 300px;
}
</style>
